import { SharedBuyerLinks } from '../../../../../SharedHeader/SharedBuyerLinks'

export const BuyerLinks = () => {
  return <SharedBuyerLinks isMobile />
}
